module.exports = __webpack_public_path__ + "static/media/no_result.29db7dd1.svg";